import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { apiUrl, getErrorMessage } from '../utils/api';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');
    setBusy(true);

    try {
      const { data } = await axios.post(apiUrl('/api/auth/password/forgot'), { email });
      setMessage(data.message || 'If an account exists, a reset link has been sent.');
    } catch (err) {
      setError(getErrorMessage(err, 'Could not send the reset email.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page auth-page">
      <form className="panel auth-card" onSubmit={handleSubmit}>
        <p className="eyebrow">Account security</p>
        <h1>Forgot password</h1>
        <p className="muted-text">Enter your email and we’ll send a reset link if the account exists.</p>
        <input type="email" placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <button type="submit" disabled={busy}>{busy ? 'Sending…' : 'Send reset email'}</button>
        {message && <p className="success-message">{message}</p>}
        {error && <p className="error-message">{error}</p>}
        <p className="muted-text"><Link to="/login">Back to login</Link></p>
      </form>
    </div>
  );
}

export default ForgotPassword;
